<template>
  <v-row no-gutters>
    <v-col cols="4">
      <v-container class="px-8 fill-height">
        <v-row class="fill-height" align="stretch">
          <v-col cols="12">
            <v-row>
              <v-col cols="5">
                <v-img src="@/assets/logo-blue.svg" />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row justify="center">
              <v-col cols="8">
                <v-row>
                  <v-col>
                    <h2>
                      Acessar
                    </h2>
                  </v-col>
                </v-row>

                <v-form @submit.prevent="login">
                  <v-row dense v-if="error">
                    <v-col>
                      <v-alert dense border="left" text type="error" class="text-subtitle-2">
                        {{ error }}
                      </v-alert>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="cpf"
                        label="CPF"
                        hide-details
                        outlined
                        dense
                        placeholder=" "
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="password"
                        label="Senha"
                        type="password"
                        hide-details
                        outlined
                        dense
                        placeholder="Sua senha é sua data de nascimento"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-btn color="primary" block type="subimit">acessar</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row justify="center" align="end" class="fill-height">
              <v-col cols="auto">
                <v-row no-gutters justify="center">
                  <v-col cols="auto" class="font-weight-bold text-caption">
                    EagleSoft v.1
                  </v-col>
                </v-row>

                <v-row no-gutters justify="center">
                  <v-col cols="auto" class="font-weight-bold secondary2--text text-caption">
                    Donato Hospital de Olhos
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-col>

    <v-col class="login-bg pr-5">
      <!-- <v-row align="end" justify="end" class="fill-height">
        <v-col cols="9" class="">
          <v-img src="@/assets/login-backgroud.svg" />
        </v-col>
      </v-row> -->
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "PatientLogin",
    data() {
      return {
        cpf: "",
        password: "",
        error: null,
      };
    },
    methods: {
      login() {
        this.error = null;

        this.$store
          .dispatch("authentication/signIn", {
            cpf: this.cpf,
            password: this.password,
          })
          .then(() => {
            this.backToHome();
          })
          .catch(() => {
            this.error = "Email ou senha inválidos.";
          });
      },
      backToHome() {
        if (this.$route.query.redirectTo && this.$route.query.redirectTo !== "/login") {
          this.$router.push(this.$route.query.redirectTo);
        } else {
          this.$router.push("/paciente");
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .login-bg {
    height: 100vh;
    background: rgb(46, 86, 228);
    background: linear-gradient(45deg, rgba(46, 86, 228, 1) 0%, rgba(101, 219, 226, 1) 100%);
  }
</style>
